import { CITIES, formatPriceUnit } from "./vegetable_catalog.js";

const FRUIT_SLUGS = {
  bangalore: "karnataka",
  coimbatore: "tamilnadu",
  oddanchatram: "tamilnadu",
  madurai: "tamilnadu",
  chennai: "koyambedu",
  mumbai: null,
  delhi: null,
};

export const FRUIT_CITIES = CITIES.map((city) => ({
  ...city,
  fruitSlug: FRUIT_SLUGS[city.id] ?? null,
}));

const FRUIT_LABELS = {
  applewashington: "Apple (Washington)",
  appleshimla: "Apple (Shimla)",
  applegreen: "Apple (Green)",
  applefuji: "Apple (Fuji)",
  bananamorris: "Banana (Morris)",
  bananafruit: "Banana",
  bananapoovam: "Banana (Poovam)",
  bananahills: "Banana (Hills)",
  bananakarpoora: "Banana (Karpoora)",
  banananeinthram: "Banana (Nendran)",
  bananared: "Banana (Red)",
  blackgrapes: "Grapes (Black)",
  grapesblack: "Grapes (Black)",
  grapesgreen: "Grapes (Green)",
  mosumbi: "Sweet Lime",
  pomegranate: "Pomegranate",
  custardapple: "Custard Apple",
  sugarcane: "Sugarcane",
  cantaloupe: "Musk Melon",
};

const FRUIT_EMOJI = {
  applewashington: "🍎",
  appleshimla: "🍎",
  applegreen: "🍏",
  applefuji: "🍎",
  apricot: "🍑",
  avocado: "🥑",
  bananamorris: "🍌",
  bananafruit: "🍌",
  bananapoovam: "🍌",
  bananahills: "🍌",
  bananakarpoora: "🍌",
  banananeinthram: "🍌",
  bananared: "🍌",
  cantaloupe: "🍈",
  custardapple: "🍐",
  gooseberry: "🫐",
  grapesblack: "🍇",
  grapesgreen: "🍇",
  blackgrapes: "🍇",
  guava: "🟢",
  jackfruit: "🟡",
  lychee: "🔴",
  mango: "🥭",
  orange: "🍊",
  papaya: "🧡",
  pears: "🍐",
  pineapple: "🍍",
  pomegranate: "🍎",
  sapota: "🟤",
  sugarcane: "🎋",
  mosumbi: "🍋",
  watermelon: "🍉",
};

export const FEATURED_FRUIT_IDS = [
  "bananafruit",
  "mango",
  "appleshimla",
  "orange",
  "papaya",
  "watermelon",
  "pomegranate",
  "pineapple",
  "guava",
  "grapesgreen",
];

export const FEATURED_FRUIT_STORAGE_KEY = "fruit-featured-ids";

export function fruitLabel(id, fallback) {
  if (FRUIT_LABELS[id]) {
    return FRUIT_LABELS[id];
  }
  if (fallback) {
    return fallback;
  }
  return id;
}

export function fruitEmoji(id) {
  return FRUIT_EMOJI[id] || "🍎";
}

export function loadFeaturedFruitIds() {
  try {
    const raw = localStorage.getItem(FEATURED_FRUIT_STORAGE_KEY);
    if (!raw) {
      return [...FEATURED_FRUIT_IDS];
    }
    const parsed = JSON.parse(raw);
    if (
      !Array.isArray(parsed) ||
      parsed.some((id) => typeof id !== "string" || !id.trim())
    ) {
      return [...FEATURED_FRUIT_IDS];
    }
    return [...new Set(parsed.map((id) => id.trim()))];
  } catch {
    return [...FEATURED_FRUIT_IDS];
  }
}

export function saveFeaturedFruitIds(ids) {
  try {
    localStorage.setItem(FEATURED_FRUIT_STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // Ignore quota / private-mode failures.
  }
}

export { CITIES, formatPriceUnit };
